import React from 'react'
import { termsAndPrivacy } from '../../utils/copys'
import { Link } from 'react-router-dom'
import Button from '../Button'
import { TermsOrPrivacy } from '../../utils/constants'

export type ModelContentType = 'terms' | 'privacy' | 'both';

type ModalTermsProps = {
    onClickAccept: React.MouseEventHandler<HTMLButtonElement>,
    onClickReject: React.MouseEventHandler<HTMLButtonElement>,
    modalContentType?: ModelContentType,
}

const ModalTerms = ({ onClickAccept, onClickReject, modalContentType }: ModalTermsProps) => {
    return (
        <div className='bg-white rounded-xl flex flex-col py-8 px-4 justify-center items-center gap-2 w-4/5'>
            <div className='pt-5 font-libre-franklin text-base text-center'>
                {
                    modalContentType === 'terms' && (
                        <>
                            <div className='font-bold'>{termsAndPrivacy.modal.text.terms[0]}</div>
                            <Link id='link_terms' to={'/terms/' + TermsOrPrivacy.TERMS} className='font-bold text-[#3131DD] underline'>{termsAndPrivacy.modal.text.terms[1]}</Link>
                            <div>{termsAndPrivacy.modal.text.terms[2]}</div>
                        </>
                    )
                }
                {
                    modalContentType === 'privacy' && (
                        <>
                            <div className='font-bold'>{termsAndPrivacy.modal.text.privacy[0]}</div>
                            <Link id='link_privacy' to={'/terms/' + TermsOrPrivacy.PRIVACY} className='font-bold text-[#3131DD] underline'>{termsAndPrivacy.modal.text.privacy[1]}</Link>
                            <div>{termsAndPrivacy.modal.text.privacy[2]}</div>
                        </>
                    )
                }
                {
                    modalContentType === 'both' && (
                        <>
                            <div className='font-bold'>{termsAndPrivacy.modal.text.both[0]}</div>
                            <div>
                                <Link id='link_terms' to={'/terms/both?goto=terms'} className='font-bold text-[#3131DD] underline'>{termsAndPrivacy.modal.text.both[1]}</Link>
                                <span className='font-bold'>{termsAndPrivacy.modal.text.both[2]}</span>
                                <Link id='link_privacy' to={'/terms/both?goto=privacy'} className='font-bold text-[#3131DD] underline'>{termsAndPrivacy.modal.text.both[3]}</Link>
                            </div>
                            <div>{termsAndPrivacy.modal.text.both[4]}</div>
                        </>
                    )
                }
            </div>
            <Button id='accept' label={termsAndPrivacy.modal.buttonAccept} enabled onClick={onClickAccept} />
            <Button id='reject' label={termsAndPrivacy.modal.buttonReject} enabled className={'bg-white'} onClick={onClickReject} />
        </div>
    )
}

export default ModalTerms
